import React, { useState, useEffect } from 'react';
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText, Dropdown, Button } from 'primereact'; 
import ConfirmModal from '../../modals/confirmx';
import FeedbackModal from '../../modals/FeedbackModal';
import { getArticlesWithoutFamily, integrateFamily, getFamilies } from '../../../services/api';

const IntegrarFamilia = () => {
    const [articles, setArticles] = useState([]);
    const [families, setFamilies] = useState([]);
    const [loading, setLoading] = useState(false);
    const [globalFilter, setGlobalFilter] = useState('');
    const [selectedArticles, setSelectedArticles] = useState([]);
    const [selectedFamily, setSelectedFamily] = useState(null);
    const [confirmIntegrationVisible, setConfirmIntegrationVisible] = useState(false);
    // Estados para feedback
    const [feedbackOpen, setFeedbackOpen] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submissionComplete, setSubmissionComplete] = useState(false);
    const [submissionError, setSubmissionError] = useState(null);

    useEffect(() => {
        const fetchArticles = async () => {
            setLoading(true);
            try {
                const response = await getArticlesWithoutFamily();
                setArticles(response.data);
            } catch (error) {
                console.error('Erro ao buscar artigos sem família:', error);
            }
            setLoading(false);
        };

        const fetchFamilies = async () => {
            try {
                const response = await getFamilies();
                setFamilies(response.data);
            } catch (error) {
                console.error('Erro ao buscar famílias:', error);
            }
        };

        fetchArticles();
        fetchFamilies();
    }, []);

    const header = (
        <div className="p-d-flex p-jc-between p-ai-center">
            <span className="p-input-icon-right">
                <InputText 
                    type="search" 
                    onInput={(e) => setGlobalFilter(e.target.value)} 
                    placeholder="Pesquisar artigos sem família" 
                    style={{ width: '300px' }}
                />
                <i className="pi pi-search" style={{ right: '10px' }} />
            </span>
        </div>
    );

    // Exibe o estoque (current_quantity) retornado pelo serializer
    const stockBodyTemplate = (rowData) => {
        return rowData.current_quantity || 0;
    };

    // Exibe o nome da família ou "Sem família"
    const familyBodyTemplate = (rowData) => {
        return rowData.family ? rowData.family.name : "Sem família";
    };

    // Ações: botão para visualizar detalhes e para excluir o artigo
    const actionBodyTemplate = (rowData) => {
        return (
            <div>
                <Button 
                    label="Detalhes" 
                    icon="pi pi-info-circle" 
                    className="p-button-rounded p-button-text" 
                    onClick={() => handleViewDetails(rowData)}
                />
                <Button 
                    label="Excluir" 
                    icon="pi pi-trash" 
                    className="p-button-rounded p-button-text p-button-danger" 
                    onClick={() => handleDelete(rowData)}
                />
            </div>
        );
    };

    const handleViewDetails = (rowData) => {
        console.log("Visualizando detalhes do artigo:", rowData);
        // Implemente a navegação ou a exibição de modal com os detalhes do artigo
    };

    const handleDelete = (rowData) => {
        console.log("Excluindo artigo:", rowData);
        // Implemente a lógica para confirmar e excluir o artigo
    };

    const handleConfirmIntegration = () => {
        if (!selectedFamily) {
            alert('Por favor, selecione uma família para integração.');
            return;
        }
        setConfirmIntegrationVisible(true);
    };

    const onConfirmIntegration = async () => {
        setConfirmIntegrationVisible(false);
        setIsSubmitting(true);
        setFeedbackOpen(true);
        setSubmissionError(null);
        try {
            const integrationData = {
                family_id: selectedFamily.id,
                merchandise_ids: selectedArticles.map(article => article.id)
            };
            const response = await integrateFamily(integrationData);
            console.log('Artigos integrados:', response.data.updated);
            setSubmissionComplete(true);
        } catch (error) {
            console.error('Erro ao integrar família:', error);
            setSubmissionError(error.message || 'Erro desconhecido');
        } finally {
            setIsSubmitting(false);
        }
    };

    const onCancelIntegration = () => {
        setConfirmIntegrationVisible(false);
    };

    return (
        <>
            <Card title="Integrar Família">
                <div className="p-d-flex p-ai-center p-mb-3" style={{ gap: '1rem' }}>
                    <Dropdown 
                        value={selectedFamily} 
                        options={families} 
                        optionLabel="name" 
                        placeholder="Selecione uma Família" 
                        onChange={(e) => setSelectedFamily(e.value)} 
                        style={{ minWidth: '200px' }}
                    />
                    <Button 
                        label="Confirmar Integração" 
                        icon="pi pi-check" 
                        className="p-button-success" 
                        onClick={handleConfirmIntegration}
                    />
                </div>
                <DataTable 
                    value={articles}
                    paginator
                    rows={10}
                    header={header}
                    globalFilter={globalFilter}
                    loading={loading}
                    responsiveLayout="scroll"
                    emptyMessage="Nenhum artigo encontrado."
                    selection={selectedArticles}
                    onSelectionChange={(e) => setSelectedArticles(e.value)}
                    dataKey="id"
                >
                    <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} />
                    <Column field="reference" header="Referência" sortable />
                    <Column field="name" header="Nome" sortable />
                    <Column body={stockBodyTemplate} header="Stock" sortable />
                    <Column body={familyBodyTemplate} header="Família" sortable />
                    <Column body={actionBodyTemplate} header="Ações" exportable={false} style={{ minWidth: '8rem' }} />
                </DataTable>

                <ConfirmModal 
                    visible={confirmIntegrationVisible}
                    message="Deseja confirmar a integração destes artigos na família selecionada?"
                    onConfirm={onConfirmIntegration}
                    onCancel={onCancelIntegration}
                />
            </Card>

            <FeedbackModal 
                open={feedbackOpen}
                isSubmitting={isSubmitting}
                submissionComplete={submissionComplete}
                error={submissionError}
                onClose={() => {
                    setFeedbackOpen(false);
                    setSubmissionComplete(false);
                    setSubmissionError(null);
                }}
            />
        </>
    );
};

export default IntegrarFamilia;
